// 需求清单任务数据
let orderModel = {
    createTime: null,
    customerUserId: null,
    createUserId: null,
    outboundUserId: null,
    orderDesc: '',
    pics: [],
    status: 0,
    fatherOrderId: null,
    isOutbound: false,
    money: null,
    isPay: false,
    isDeliver: false,
    priceInfo: [],
    todayIndex: null
}
export default orderModel;